import { render, staticRenderFns } from "./activitylog.vue?vue&type=template&id=1c349c5e&"
import script from "./activitylog.js?vue&type=script&lang=js&"
export * from "./activitylog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports